import httpClient from '../../httpClient';
import {
  DataRoomMember,
  DataRoomMembers,
} from 'router/subrouters/DataRoom/models/DataRoomMember';
import { NodeChangedPermission } from 'components/FileAccessSelector/types';

function updateMemberDocuments(
  memberId: string,
  data: {
    changedPermissions?: NodeChangedPermission[];
  },
) {
  return httpClient.patch<{ dataRoomMember: DataRoomMember }>(
    `data-room-members/${memberId}`,
    data,
  );
}

/**
 * Same route as `dataRoomApi.members.getMembers`, on the platform client — needed to
 * render the file access drawer outside the Data Room.
 */

function getMembers(dataRoomId: string) {
  return httpClient.get<DataRoomMembers>(
    `data-room-members/data-rooms/${dataRoomId}`,
  );
}

export default {
  updateMemberDocuments,
  getMembers,
};
